<template>
  <div class="product-pricing-modal">
    <CustomModal :show="show"
                 @close="onClose">
      <template #header>
        <h1 class="custom-modal__heading">
          Log in to continue
        </h1>
      </template>

      <div class="product-pricing-modal__body">
        <div class="row">
          <div class="col-lg-6">
            <h2 class="product-pricing-modal__heading">
              Log in
            </h2>

            <p class="product-pricing-modal__text">
              To continue and access pricing, please log in.
            </p>

            <slot name="login"
                  :onLogin="onLogin"
                  :redirectUrl="redirectUrl">
              <login-form redirect
                          :redirect-url="redirectUrl"
                          @loggedIn="onLogin"></login-form>
            </slot>
          </div>

          <div class="col-lg-6">
            <h2 class="product-pricing-modal__heading">
              {{ registerHeading }}
            </h2>

            <div class="product-pricing-modal__text">
              <slot name="register"></slot>
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  </div>
</template>

<script>
import CustomModal from "~/Components/CustomModal.vue";
import LoginForm from "~/Components/Accounts/LoginForm.vue";

export default {
  name: "ProductPricingModal",
  components: {
    CustomModal,
    LoginForm
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    registerHeading: {
      type: String,
      default: "Not got an account?"
    }
  },
  data: () => ( {
    redirectUrl: null
  } ),
  created () {
    this.redirectUrl = window.location.href;
  },
  methods: {
    onClose () {
      this.$emit( "close" );
    },
    onLogin () {
      this.$emit( "login" );
    }
  }
};
</script>

<style lang="less" scoped>
.product-pricing-modal {
  &__heading {
    color: #000;
    font-weight: 700;
    margin-bottom: 15px;
  }

  &__body {
    padding-bottom: 15px;
  }

  &__text {
    font-size: 14px;
  }

  &__skip {
    width: 100%;
    padding: 30px 10%;
    background: #ececec;
    border-radius: 0 0 10px 10px;
  }

  &__skip-heading {
    color: #4a4a4a;
    font-size: 22px;
  }
}
</style>
